var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 82,
    viewBox: "0 0 87 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 41C81 42.5023 85.3616 43.9852 85.2003 45.4444C82.9895 65.4442 66.0336 81 45.4444 81C24.8553 81 7.89944 65.4442 5.68857 45.4444C5.52726 43.9852 1 42.5023 1 41C1 39.4977 1.08281 38.0148 1.24413 36.5556C3.45499 16.5558 20.4109 1 41 1C61.5891 1 78.545 16.5558 80.7559 36.5556C80.9172 38.0148 81 39.4977 81 41Z",
    stroke: "#F0251C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4138 41L54.9996 30.4142L53.5854 29L42.9996 39.5858L32.4143 29.0006L31.0001 30.4148L41.5853 41L31 51.5854L32.4142 52.9996L42.9996 42.4142L53.5855 53.0001L54.9997 51.5859L44.4138 41Z",
    fill: "#F0251C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.9ffb4f99.svg";
export { ForwardRef as ReactComponent };